export const ANIMAL_SPLIT_CORE = {
  development: {
    URL: process.env.REACT_APP_CORE_URL_LOCAL || "http://localhost:3001",
  },
  production: {
    URL: process.env.REACT_APP_CORE_URL_PROD || "https://animalsplit.com",
  },
};

export const ICONS = {
  dog: "🐶",
  cat: "🐱",
  rabbit: "🐰",
  fox: "🦊",
  bear: "🐻",
  panda: "🐼",
  koala: "🐨",
  tiger: "🐯",
  lion: "🦁",
  cow: "🐮",
  pig: "🐷",
  frog: "🐸",
  monkey: "🐵",
};

export const TRANSACTION_CATEGORIES = {
  meal: "🍽",
  snacks: "🍿",
  drinks: "🍹",
  transportation: "🚗",
  parking: "🅿️",
  gas: "⛽️",
  tickets: "🎫",
  accommodation: "🛌",
  rent: "🏠",
  utility: "⚡️",
  groceries: "🛒",
  insurance: "💰",
  uncategorized: "🏷",
};

export const THEME = {
  THEME_COLOR_01: "#8dddc8",
  THEME_COLOR_02: "#4b9347",
  THEME_COLOR_03: "#92cb4c",
  NEAR_WHITE: "#f8f8ff",
  NEAR_BLACK: "#100c08",
  COLOR_ALERT: "#d9595e",
};

export const MODAL_ID = {
  CONNECTION_ERROR: "connection-error-modal-id",
  EXACT_MISMATCH: "exact-mismatch-modal-id",
  UPLOAD_ERROR: "upload-error-modal-id",
  VALIDATION_ERROR: "validation-error-modal-id",
  PERMISSION_ERROR: "permission-error-modal-id",
  VENMO_OPEN_FAILED: "venmo-open-failed-modal-id",
  GENERIC_ERROR: "generic-error-modal-id",
};

// alias for enum-like usage
export const MODALS = MODAL_ID;

export const MODAL_DEFAULTS = {
  [MODAL_ID.CONNECTION_ERROR]: {
    title: "Connection error",
    message:
      "There was a problem connecting to the server. Please try again later.",
    btnTitle: "Close",
  },
  [MODAL_ID.EXACT_MISMATCH]: {
    title: "Invalid amounts",
    message:
      "The contributor amounts you entered do not add up to the total amount. Please adjust the amounts so they match the total.",
    btnTitle: "Close",
  },
  [MODAL_ID.UPLOAD_ERROR]: {
    title: "Upload failed",
    message:
      "We couldn't upload your image. Please check your network connection and try again, or try a different image.",
    btnTitle: "Close",
  },
  [MODAL_ID.VALIDATION_ERROR]: {
    title: "Invalid input",
    message:
      "Some fields are invalid or missing. Please review the form and correct any highlighted fields.",
    btnTitle: "Close",
  },
  [MODAL_ID.PERMISSION_ERROR]: {
    title: "Permission denied",
    message:
      "You don't have permission to perform this action. If you believe this is incorrect, please contact the event owner.",
    btnTitle: "Close",
  },
  [MODAL_ID.GENERIC_ERROR]: {
    title: "Something went wrong",
    message:
      "An unexpected error occurred. Please try again later. If this keeps happening, contact support with the steps to reproduce.",
    btnTitle: "Close",
  },
};

export const FRONT_URL = {
  development: {
    URL: process.env.REACT_APP_FRONT_URL_LOCAL || "http://localhost:3000",
  },
  production: {
    URL: process.env.REACT_APP_FRONT_URL_PROD || "https://animalsplit.com/",
  },
};
